export const lists_Vehicles = [
    {
        "ID": 0,
        "name": "SI‐2",
        "namelong": "Snel Inzetbare Eenheid (2 pers.)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 1,
        "name": "TS 8/9",
        "namelong": "Tankautospuit (8/9 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 2,
        "name": "AL",
        "namelong": "Autoladder",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 3,
        "name": "DA-OVD",
        "namelong": "Officier van Dienst - Brandweer",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 4,
        "name": "HV",
        "namelong": "Hulpverleningsvoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 5,
        "name": "AB",
        "namelong": "Adembeschermingsvoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 6,
        "name": "TST 8/9",
        "namelong": "Tankautospuit Terreinvaardig (8/9 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 7,
        "name": "TST 6/7",
        "namelong": "Tankautospuit Terreinvaardig (6/7 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 8,
        "name": "TST 4/5",
        "namelong": "Tankautospuit Terreinvaardig (4/5 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 9,
        "name": "TS 4/5",
        "namelong": "Tankautospuit (4/5 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 10,
        "name": "SL",
        "namelong": "Slangenwagen",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 11,
        "name": "DB-VEB",
        "namelong": "Dienstbus Verkenningseenheid Brandweer",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 12,
        "name": "TST-NB 8/9",
        "namelong": "Tankautospuit Natuurbrandbestrijding (8/9 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 14,
        "name": "TST-NB 6/7",
        "namelong": "Tankautospuit Natuurbrandbestrijding (6/7 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 15,
        "name": "TST-NB 4/5",
        "namelong": "Tankautospuit Natuurbrandbestrijding (4/5 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 16,
        "name": "Ambulance",
        "namelong": "Ambulance",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 17,
        "name": "TS 6/7",
        "namelong": "Tankautospuit (6/7 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 18,
        "name": "HW",
        "namelong": "Hoogwerker",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 19,
        "name": "DA-HOD",
        "namelong": "Hoofd Officier van Dienst - Brandweer",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 20,
        "name": "DA",
        "namelong": "Dienstauto (4 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 21,
        "name": "DB-K",
        "namelong": "Dienstbus klein (9 personen)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 22,
        "name": "DA Noodhulp",
        "namelong": "Dienstauto Noodhulp",
        "categorie": ["Politie"]
    },
    {
        "ID": 23,
        "name": "Lifeliner",
        "namelong": "Lifeliner",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 24,
        "name": "DA-AGS",
        "namelong": "Adviseur Gevaarlijke Stoffen - Brandweer",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 25,
        "name": "DB Noodhulp",
        "namelong": "Dienstbus Noodhulp",
        "categorie": ["Politie"]
    },
    {
        "ID": 26,
        "name": "HA",
        "namelong": "Haakarmvoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 27,
        "name": "ABH",
        "namelong": "Adembeschermingshaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 28,
        "name": "Politiehelikopter",
        "namelong": "Politiehelikopter",
        "categorie": ["Politie"]
    },
    {
        "ID": 29,
        "name": "WTH",
        "namelong": "Watertankhaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 30,
        "name": "Zorgambulance",
        "namelong": "B-ambulance",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 31,
        "name": "CO",
        "namelong": "Commandovoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 32,
        "name": "COH",
        "namelong": "Commandohaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 33,
        "name": "WO",
        "namelong": "Waterongevallenvoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 34,
        "name": "WT",
        "namelong": "Watertankwagen",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 35,
        "name": "OVD-P",
        "namelong": "Officier van Dienst - Politie",
        "categorie": ["Politie"]
    },
    {
        "ID": 36,
        "name": "WOA",
        "namelong": "Waterongevallenaanhanger",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 37,
        "name": "MMT-Auto",
        "namelong": "MMT-Auto",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 38,
        "name": "OvD-G",
        "namelong": "Officier van Dienst Geneeskunde",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 39,
        "name": "ME Commandovoertuig",
        "namelong": "ME Commandovoertuig",
        "categorie": ["Politie"]
    },
    {
        "ID": 40,
        "name": "ME Flex",
        "namelong": "ME Flexbus",
        "categorie": ["Politie"]
    },
    {
        "ID": 41,
        "name": "CT (8x8)",
        "namelong": "Crashtender (8x8)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 42,
        "name": "CT (6x6)",
        "namelong": "Crashtender (6x6)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 43,
        "name": "CT (4x4)",
        "namelong": "Crashtender (4x4)",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 44,
        "name": "AFO/OSC",
        "namelong": "Airport fire Officer / On Scene Commander",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 45,
        "name": "DPH",
        "namelong": "Dompelpomphaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 46,
        "name": "DM-P",
        "namelong": "Dienstmotor Politie",
        "categorie": ["Politie"]
    },
    {
        "ID": 47,
        "name": "DA Hondengeleider",
        "namelong": "Dienstauto Hondengeleider",
        "categorie": ["Politie"]
    },
    {
        "ID": 48,
        "name": "DB Hondengeleider",
        "namelong": "Dienstbus Hondengeleider",
        "categorie": ["Politie"]
    },
    {
        "ID": 49,
        "name": "PM-OR",
        "namelong": "Materieelvoertuig - Oppervlakteredding",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 50,
        "name": "TS-OR",
        "namelong": "Tankautospuit - Oppervlakteredding",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 51,
        "name": "HVH",
        "namelong": "Hulpverleningshaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 52,
        "name": "RR",
        "namelong": "Rapid Responder",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 53,
        "name": "AT-C",
        "namelong": "AT-Commandant",
        "categorie": ["Politie"]
    },
    {
        "ID": 54,
        "name": "AT-O",
        "namelong": "AT-Operator",
        "categorie": ["Politie"]
    },
    {
        "ID": 55,
        "name": "AT-M",
        "namelong": "AT-Materiaalwagen",
        "categorie": ["Politie"]
    },
    {
        "ID": 56,
        "name": "DA-VL",
        "namelong": "Dienstauto Voorlichter",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 57,
        "name": "DA OVDG-RR",
        "namelong": "Dienstvoertuig Officier van Dienst-Geneeskundig/Rapid Responder",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 58,
        "name": "DB-AV",
        "namelong": "Dienstbus - Arrestantenvervoer",
        "categorie": ["Politie"]
    },
    {
        "ID": 59,
        "name": "NH-O",
        "namelong": "Noodhulp - Onopvallend",
        "categorie": ["Politie"]
    },
    {
        "ID": 60,
        "name": "DB-Bike",
        "namelong": "Dienstbus Biketeam",
        "categorie": ["Politie"]
    },
    {
        "ID": 61,
        "name": "SLH",
        "namelong": "Slangenhaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 62,
        "name": "TS-HV",
        "namelong": "Tankautospuit-Hulpverlening",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 63,
        "name": "DM-RR",
        "namelong": "Rapid Responder - Motor",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 64,
        "name": "ME-AE",
        "namelong": "ME - Aanhoudingseenheid",
        "categorie": ["Politie"]
    },
    {
        "ID": 65,
        "name": "DAT-RB",
        "namelong": "Dienstauto Terreinwaardig - Reddingsbrigade",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 66,
        "name": "KHV",
        "namelong": "Kusthulpverleningsvoertuig",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 67,
        "name": "BA-RB",
        "namelong": "Bootaanhanger Reddingsbrigade",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 68,
        "name": "SB",
        "namelong": "Schuimblusvoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 69,
        "name": "SBH",
        "namelong": "Schuimblushaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 70,
        "name": "SBA",
        "namelong": "Schuimblusaanhanger",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 71,
        "name": "MSA",
        "namelong": "Motorspuitaanhanger",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 72,
        "name": "DPA",
        "namelong": "Dompelpompaanhangwagen",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 73,
        "name": "VW-BB",
        "namelong": "Vrachtwagen – Bereden Brigade",
        "categorie": ["Politie"]
    },
    {
        "ID": 74,
        "name": "BB-A",
        "namelong": "Bereden Brigade Aanhanger",
        "categorie": ["Politie"]
    },
    {
        "ID": 75,
        "name": "DAT-NH",
        "namelong": "Dienstauto terreinvaardig - Noodhulp",
        "categorie": ["Politie"]
    },
    {
        "ID": 76,
        "name": "Quad",
        "namelong": "Quad Reddingsbrigade",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 77,
        "name": "KW-Boot",
        "namelong": "Kustwacht boot",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 78,
        "name": "RB-K",
        "namelong": "Reddingsboot klein",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 79,
        "name": "RB-G",
        "namelong": "Reddingsboot groot",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 80,
        "name": "SAR-Heli",
        "namelong": "SAR helikopter",
        "categorie": ["Kustwacht"]
    },
    {
        "ID": 81,
        "name": "DA-RWS",
        "namelong": "Dienstvoertuig weginspecteur Rijkswaterstaat",
        "categorie": ["RWS"]
    },
    {
        "ID": 82,
        "name": "DM-RWS",
        "namelong": "Dienstmotor weginspecteur Rijkswaterstaat",
        "categorie": ["RWS"]
    },
    {
        "ID": 83,
        "name": "DA-SIG",
        "namelong": "Signalisatievoertuig",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 84,
        "name": "Waterwerper",
        "namelong": "Waterwerper",
        "categorie": ["Politie"]
    },
    {
        "ID": 85,
        "name": "FBO-Heli",
        "namelong": "Fire Bucket Operations - Helikopter",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 86,
        "name": "DB-Handcrew",
        "namelong": "Dienstbus – Handcrew",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 87,
        "name": "DA-LA-NB",
        "namelong": "Dienstauto – Landelijk adviseur Natuurbranden",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 88,
        "name": "VW-NB",
        "namelong": "Vrachtwagen – Natuurbrandbestrijding",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 89,
        "name": "NBH",
        "namelong": "Natuurbrandbestrijdingshaakarmbak",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 90,
        "name": "TS-STH",
        "namelong": "Tankautospuit – Specialisme Technische Hulpverlening",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 91,
        "name": "HVH-STH",
        "namelong": "Hulpverleningshaakarmbak-Specialisme Technische Hulpverlening",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 92,
        "name": "DB-USAR",
        "namelong": "Dienstbus – Urban Search and Rescue",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 93,
        "name": "TS-USAR",
        "namelong": "Tankautospuit – Urban Search and Rescue",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 94,
        "name": "VW-USAR",
        "namelong": "Vrachtwagen – Urban Search and Rescue",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 95,
        "name": "DM-USAR",
        "namelong": "Dienstmotor – Urban Search and Rescue",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 96,
        "name": "Quad-USAR",
        "namelong": "Quad – Urban Search and Rescue",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 97,
        "name": "DB–Speurhonden",
        "namelong": "Dienstbus – Speurhonden",
        "categorie": ["Brandweer"]
    },
    {
        "ID": 98,
        "name": "SIV-P",
        "namelong": "Snelle Interventievoertuig Politie",
        "categorie": ["Politie"]
    },
    {
        "ID": 99,
        "name": "DB-VOA",
        "namelong": "Dienstbus - Verkeersongevalleanalyse",
        "categorie": ["Politie"]
    },
    {
        "ID": 100,
        "name": "GGB",
        "namelong": "Calamiteitenvoertuig GGB",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 101,
        "name": "NHT",
        "namelong": "Noodhulpteam Rode Kruis",
        "categorie": ["Ambulance"]
    },
    {
        "ID": 102,
        "name": "MC-Ambulance",
        "namelong": "Medium Care Ambulance",
        "categorie": ["Ambulance"]
    },
]

export const lists_vehicleGroups = [
    {
        "name": "Mobiel Medisch Team",
        "texts": ["MMT-Arts"],
        "vehicles": [23, 37, 80],
        "type": ["Ambulance"]
    },
    {
        "name": "Rapid Responders",
        "texts": [],
        "vehicles": [52, 57, 63],
        "type": ["Ambulance"],
        "ignoreByAlarmoverview": true
    },
    {
        "name": "Ambulances",
        "texts": ["Ambulance", "Ambulances"],
        "vehicles": [16, 52, 57, 63, 102],
        "type": ["Ambulance"]
    },
    {
        "name": "Officier van Dienst - Geneeskunde",
        "texts": ["OVD-G"],
        "vehicles": [38, 57],
        "type": ["Ambulance"]
    },
    {
        "name": "Tankautospuiten",
        "texts": ["Tankautospuit", "Tankautospuiten"],
        "vehicles": [0, 1, 6, 7, 8, 9, 12, 14, 15, 17, 50, 90, 93],
        "type": ["Brandweer"]
    },
    {
        "name": "Redvoertuigen",
        "texts": ["Redvoertuig", "Redvoertuigen"],
        "vehicles": [2, 18],
        "type": ["Brandweer"]
    },
    {
        "name": "Dienstvoertuigen",
        "texts": [],
        "vehicles": [20, 21],
        "type": ["Brandweer"],
        "ignoreByAlarmoverview": true
    },
    {
        "name": "Waterongevallen/Oppervlakteredding",
        "texts": ["Waterongevallenvoertuig / Oppervlaktereddingsteam", "Waterongevallenvoertuigen / Oppervlaktereddingsteams"],
        "vehicles": [33, 49, 50],
        "type": ["Brandweer"]
    },
    {
        "name": "Crashtenders",
        "texts": ["Crashtender", "Crashtenders"],
        "vehicles": [41, 42, 43],
        "type": ["Brandweer"]
    },
    {
        "name": "Airport Officieren",
        "texts": ["AFO/OSC", "AFO/OSC's"],
        "vehicles": [44],
        "type": ["Brandweer"]
    },
    {
        "name": "Hulpverleningsvoertuigen",
        "texts": ["Hulpverleningsvoertuig", "Hulpverleningsvoertuigen"],
        "vehicles": [4, 51],
        "type": ["Brandweer"]
    },
    {
        "name": "Adembeschermingsvoertuigen",
        "texts": ["AB"],
        "vehicles": [5, 27],
        "type": ["Brandweer"]
    },
    {
        "name": "Commandowagens",
        "texts": ["Commandowagen", "Commandowagens"],
        "vehicles": [31, 32],
        "type": ["Brandweer"]
    },
    {
        "name": "Schuimblusvoertuigen",
        "texts": ["Schuimblusvoertuig", "Schuimblusvoertuigen"],
        "vehicles": [68, 69, 70],
        "type": ["Brandweer"]
    },
    {
        "name": "Pompvoertuigen",
        "texts": ["Pompvoertuig", "Pompvoertuigen"],
        "vehicles": [45, 71, 72],
        "type": ["Brandweer"]
    },
    {
        "name": "Officeren van Dienst - Brandweer",
        "texts": ["Officier van Dienst - Brandweer", "Officieren van Dienst - Brandweer"],
        "vehicles": [3, 19],
        "type": ["Brandweer"]
    },
    {
        "name": "Slangenwagen/Watertransport",
        "texts": ["Slangenwagen, watertankwagen of gelijkwaardige haakarmbak"],
        "vehicles": [10, 34, 29, 45, 61, 68],
        "type": ["Brandweer"]
    },
    {
        "name": "Noodhulpeenheden",
        "texts": ["Noodhulpeenheden", "Noodhulpeenheid"],
        "vehicles": [22, 25, 46, 47, 48, 59, 60, 75, 98],
        "type": ["Politie"]
    },
    {
        "name": "Bereden Brigade voertuigen",
        "texts": ["Bereden Brigade eenheid (paard)", "Bereden Brigade eenheden (paarden)"],
        "vehicles": [73, 74],
        "type": ["Politie"]
    },
    {
        "name": "Hondengeleiders",
        "texts": ["Hondengeleider", "Hondengeleiders"],
        "vehicles": [47, 48],
        "type": ["Politie"]
    },
    {
        "name": "Strandvoertuigen",
        "texts": ["Strandvoertuig", "Strandvoertuigen",],
        "vehicles": [65, 66, 76],
        "type": ["Kustwacht"]
    },
    {
        "name": "Bootaanhangers",
        "texts": ["WOA of BA-RB"],
        "vehicles": [36, 67],
        "type": ["Kustwacht", "Brandweer"]
    },
    {
        "name": "Reddingsboten",
        "texts": ["Kleine of Grote Reddingsboot", "Kleine of Grote Reddingsboten"],
        "vehicles": [78, 79],
        "type": ["Kustwacht"]
    },
    {
        "name": "Signalisatievoertuigen",
        "texts": ["Signalisatie Voertuig", "Signalisatie Voertuigen"],
        "vehicles": [81, 82, 83],
        "type": ["RWS", "Brandweer"]
    },
    {
        "name": "Voorlichters",
        "texts": ["Voorlichter", "Voorlichters"],
        "vehicles": [56],
        "type": ["Brandweer"]
    },
    {
        "name": "Hoofd officier van Dienst",
        "texts": ["Hoofd Officier van Dienst", "Hoofd Officieren van Dienst"],
        "vehicles": [16],
        "type": ["Brandweer"]
    },
    {
        "name": "Verkenningseenheden",
        "texts": ["Verkenningseenheden", "Verkenningseenheid"],
        "vehicles": [11],
        "type": ["Brandweer"]
    },
    {
        "name": "Adviseurs Gevaarlijke Stoffen",
        "texts": ["Adviseur Gevaarlijke Stoffen", "Adviseurs Gevaarlijke Stoffen"],
        "vehicles": [24],
        "type": ["Brandweer"]
    },
    {
        "name": "Officieren van Dienst - Politie",
        "texts": ["Officier van Dienst - Politie", "Officieren van Dienst - Politie"],
        "vehicles": [35],
        "type": ["Politie"]
    },
    {
        "name": "Politiehelikopters",
        "texts": ["Politiehelikopter"],
        "vehicles": [28],
        "type": ["Politie"]
    },
    {
        "name": "ME Commandovoertuigen",
        "texts": ["ME Commandovoertuig", "ME Commandovoertuigen"],
        "vehicles": [39],
        "type": ["Politie"]
    },
    {
        "name": "ME Flexvoertuigen",
        "texts": ["ME Flexbus", "ME Flexbussen"],
        "vehicles": [40],
        "type": ["Politie"]
    },
    {
        "name": "AT Commandovoertuigen",
        "texts": ["AT Commandant", "AT Commandanten"],
        "vehicles": [53],
        "type": ["Politie"]
    },
    {
        "name": "AT Materiaalwagens",
        "texts": ["AT Materiaalwagen", "AT Materiaalwagens"],
        "vehicles": [55],
        "type": ["Politie"]
    },
    {
        "name": "AT Operators",
        "texts": ["AT Operator", "AT Operators"],
        "vehicles": [54],
        "type": ["Politie"]
    },
    {
        "name": "Biketeams",
        "texts": ["Biketeam", "Biketeams"],
        "vehicles": [60],
        "type": ["Politie"]
    },
    {
        "name": "ME Aanhoudingseenheid",
        "texts": ["Aanhoudingseenheden", "Aanhoudingseenheid"],
        "vehicles": [64],
        "type": ["Politie"]
    },
    {
        "name": "Dienstbussen Arrestantenvervoer",
        "texts": ["Dienstbus Arrestantenvervoer", "Dienstbussen Arrestantenvervoer"],
        "vehicles": [58],
        "type": ["Politie"]
    },
    {
        "name": "DM-RWS",
        "texts": ["DM-RWS"],
        "vehicles": [82],
        "type": ["RWS"]
    },
    {
        "name": "KW-boten",
        "texts": ["KW-boot", "KW-boten"],
        "vehicles": [77],
        "type": ["Kustwacht"]
    },
    {
        "name": "Quads",
        "texts": ["Quad", "Quads"],
        "vehicles": [76],
        "type": ["Kustwacht"]
    },
    {
        "name": "SAR-helicopters",
        "texts": ["SAR-helicopter", "SAR-helicopters"],
        "vehicles": [80],
        "type": ["Kustwacht"]
    },
    {
        "name": "Waterwerpers",
        "texts": ["Waterwerper", "Waterwerpers"],
        "vehicles": [84],
        "type": ["Politie"]
    },
    {
        "name": "Terreinvaardige Tankautospuiten",
        "texts": ["Terreinvaardige Tankautospuit", "Terreinvaardige Tankautospuiten"],
        "vehicles": [6, 7, 8, 12, 14, 15],
        "type": ["Brandweer"]
    },
    {
        "name": "FBO-Heli",
        "texts": ["FBO Hel", "FBO Helis"],
        "vehicles": [85],
        "type": ["Brandweer"]
    },
    {
        "name": "DB-Handcrew",
        "texts": ["Dienstbus Handcrew", "Dienstbussen Handcrew"],
        "vehicles": [86],
        "type": ["Brandweer"]
    },
    {
        "name": "DA-LA-NB",
        "texts": ["Landelijk Advieseur Natuurbranden", "Landelijk Advieseurs Natuurbranden"],
        "vehicles": [87],
        "type": ["Brandweer"]
    },
    {
        "name": "NatuurbrandBestrijdingsmaterieel",
        "texts": ["NatuurbrandBestrijdingsmaterieel"],
        "vehicles": [88, 89],
        "type": ["Brandweer"]
    },
    {
        "name": "TS-TSH",
        "texts": ["TS-STH"],
        "vehicles": [90],
        "type": ["Brandweer"]
    },
    {
        "name": "HVH-TSH",
        "texts": ["HVH-STH"],
        "vehicles": [91],
        "type": ["Brandweer"]
    },
    {
        "name": "Dienstvoertuigen USAR",
        "texts": ["Dienstvoertuig USAR", "Dienstvoertuigen USAR"],
        "vehicles": [92, 95, 96],
        "type": ["Brandweer"]
    },
    {
        "name": "TS-USAR",
        "texts": ["TS-USAR"],
        "vehicles": [93],
        "type": ["Brandweer"]
    },
    {
        "name": "VW-USAR",
        "texts": ["VW-USAR"],
        "vehicles": [94],
        "type": ["Brandweer"]
    },
    {
        "name": "Dienstbussen - Speurhonden",
        "texts": ["Dienstbus-Speurhonden", "Dienstbussen-Speurhonden"],
        "vehicles": [97],
        "type": ["Brandweer"]
    },
    {
        "name": "Dienstmotoren Politie",
        "texts": ["DM-P"],
        "vehicles": [46],
        "type": ["Politie"]
    },
    {
        "name": "Snelle Interventievoertuigen Politie",
        "texts": ["SIV-P"],
        "vehicles": [46, 98],
        "type": ["Politie"]
    },
    {
        "name": "Dienstbussen - Verkeersongevalleanalyse",
        "texts": ["DB-VOA"],
        "vehicles": [99],
        "type": ["Politie"]
    },
    {
        "name": "Calamiteitenvoertuigen GGB",
        "texts": ["GGB"],
        "vehicles": [100],
        "type": ["Ambulance"]
    },
    {
        "name": "Noodhulpteam Rode Kruis",
        "texts": ["NHT"],
        "vehicles": [101],
        "type": ["Ambulance"]
    },
]

export const lists_additionalVehicleValues = [
    {
        "name": "Liters Water (geen Boost)",
        "type": ["Brandweer"],
        "Voertuigen": [
            {
                "id": 0,
                "amount": 500
            },
            {
                "id": 1,
                "amount": 2000
            },
            {
                "id": 6,
                "amount": 3000
            },
            {
                "id": 7,
                "amount": 3000
            },
            {
                "id": 8,
                "amount": 2000
            },
            {
                "id": 9,
                "amount": 1500
            },
            {
                "id": 12,
                "amount": 4000
            },
            {
                "id": 14,
                "amount": 4000
            },
            {
                "id": 15,
                "amount": 4000
            },
            {
                "id": 17,
                "amount": 2000
            },
            {
                "id": 29,
                "amount": 10000
            },
            {
                "id": 34,
                "amount": 15000
            },
            {
                "id": 41,
                "amount": 13300
            },
            {
                "id": 42,
                "amount": 10000
            },
            {
                "id": 43,
                "amount": 6000
            },
            {
                "id": 50,
                "amount": 2000
            },
            {
                "id": 62,
                "amount": 2000
            },
            {
                "id": 68,
                "amount": 10000
            },
            {
                "id": 69,
                "amount": 8000
            },
            {
                "id": 90,
                "amount": 2000
            },
            {
                "id": 93,
                "amount": 2000
            }
        ]
    },
    {
        "name": "Liters SVM",
        "type": ["Brandweer"],
        "Voertuigen": [
            {
                "id": 41,
                "amount": 1600
            },
            {
                "id": 42,
                "amount": 1300
            },
            {
                "id": 43,
                "amount": 500
            },
            {
                "id": 68,
                "amount": 1000
            },
            {
                "id": 69,
                "amount": 1000
            },
            {
                "id": 70,
                "amount": 500
            }
        ]
    },
    {
        "name": "Paarden (volle voertuigen)",
        "type": ["Politie"],
        "Voertuigen": [
            {
                "id": 73,
                "amount": 4
            },
            {
                "id": 74,
                "amount": 2
            }
        ]
    },
    {
        "name": "Patiënten behandeling",
        "type": ["Ambulance"],
        "Voertuigen": [
            {
                "id": 16,
                "amount": 1
            },
            {
                "id": 52,
                "amount": 1
            },
            {
                "id": 57,
                "amount": 1
            },
            {
                "id": 63,
                "amount": 1
            },
            {
                "id": 100,
                "amount": 6
            },
            {
                "id": 101,
                "amount": 6
            },
            {
                "id": 102,
                "amount": 1
            }
        ]
    },
    {
        "name": "Max arrestanten transport tegelijk",
        "type": ["Politie"],
        "Voertuigen": [
            {
                "id": 22,
                "amount": 1
            },
            {
                "id": 25,
                "amount": 1
            },
            {
                "id": 54,
                "amount": 1
            },
            {
                "id": 58,
                "amount": 5
            },
            {
                "id": 59,
                "amount": 1
            },
            {
                "id": 60,
                "amount": 1
            },
            {
                "id": 64,
                "amount": 1
            }
        ]
    },
    {
        "name": "Pompcapaciteit (L/min.)",
        "type": ["Brandweer"],
        "Voertuigen": [
            {
                "id": 0,
                "amount": 250
            },
            {
                "id": 1,
                "amount": 2000
            },
            {
                "id": 6,
                "amount": 2500
            },
            {
                "id": 7,
                "amount": 1800
            },
            {
                "id": 8,
                "amount": 1000
            },
            {
                "id": 9,
                "amount": 800
            },
            {
                "id": 10,
                "amount": 1000
            },
            {
                "id": 12,
                "amount": 3500
            },
            {
                "id": 14,
                "amount": 2000
            },
            {
                "id": 41,
                "amount": 8000
            },
            {
                "id": 42,
                "amount": 6000
            },
            {
                "id": 43,
                "amount": 3000
            },
            {
                "id": 45,
                "amount": 6000
            },
            {
                "id": 50,
                "amount": 1500
            },
            {
                "id": 62,
                "amount": 1500
            },
            {
                "id": 68,
                "amount": 1000
            },
            {
                "id": 69,
                "amount": 1000
            },
            {
                "id": 71,
                "amount": 1000
            },
            {
                "id": 75,
                "amount": 2500
            },
            {
                "id": 90,
                "amount": 2000
            },
            {
                "id": 93,
                "amount": 2000
            }
        ]
    }
]
